import Backdraft from "backdraft-app/src/backdraft";

Backdraft.app("Header", function(app) {

  app.model("Integration", {

    sync: app.sync,

    addToAccount: function() {
      return this.sync("update", this, {
        url: app.config.urlConfig.addIntegrationToAccount,
        attrs: { name: this.get('name'), already_set_up: this.get('self_serve_on_other_org_type?') }
      });
    }

  });

});
